import { render, staticRenderFns } from "./Election.vue?vue&type=template&id=6493bf0c&scoped=true&"
import script from "./Election.vue?vue&type=script&lang=js&"
export * from "./Election.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Election.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Election.vue?vue&type=style&index=2&id=6493bf0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493bf0c",
  null
  
)

export default component.exports